export default __webpack_public_path__ + "static/media/normal_trans.8c98fa7a.svg";